import { ANALYTICS } from '../../constants/common';
import { trackFormInput } from './analyticEvents';

/**
 * @method trackQualityChecksOutCome
 * @description this method tracks quality checks outcome and optionally tracks recommendations count
 * @param {string} qualityCheckStatus (quality check status) [status of the quality check outcome]
 * @param {string} userEncodedNtid (user encoded ntid) [user encoded ntid for tracking purposes]
 * @param {number} [recommendationsCount] (optional recommendations count) [number of applicable recommendations available, only tracked if provided]
 */
export const trackQualityChecksOutCome = (
  qualityCheckStatus: string,
  userEncodedNtid: string,
  recommendationsCount?: number
) => {
  trackFormInput(
    ANALYTICS.QUALITY_CHECKS_FORM_NAME,
    ANALYTICS.STEP,
    ANALYTICS.QC_OUTCOME_QUESTION_NAME,
    qualityCheckStatus,
    '1'
  );

  // Track recommendations count only if provided
  if (recommendationsCount !== undefined && recommendationsCount > 0) {
    trackFormInput(
      ANALYTICS.QUALITY_CHECKS_FORM_NAME,
      ANALYTICS.STEP,
      ANALYTICS.QC_RECOMMENDATIONS_COUNT_QUESTION_NAME,
      recommendationsCount.toString(),
      '2'
    );
  }

  if (userEncodedNtid !== '') {
    trackFormInput(
      ANALYTICS.QUALITY_CHECKS_FORM_NAME,
      ANALYTICS.STEP,
      ANALYTICS.USER_ENCODED_NTID_QUESTION_NAME,
      userEncodedNtid,
      '3'
    );
  }
};
